function UnHide()
{
  let IsDebugMode = window.location.href.match(/debug=brodbar/) || window.location.href.match(/myshopify/);
  if(IsDebugMode)
  {
      [...document.querySelectorAll(".debug_hidden")].forEach(e => e.classList.remove("debug_hidden"));
  }
}

window.addEventListener('DOMContentLoaded', () =>
{
  UnHide();
  /*
  const Timer = setInterval(() =>
  {
    UnHide();
  }, 1000);*/
  AddStyle();
  //AddVintageButton();
});

function AddStyle()
{
  
  let IsDebugMode = window.location.href.match(/debug=brodbar/) || window.location.href.match(/myshopify/);
}

function AddVintageButton()
{
  let IsDebugMode = window.location.href.match(/debug=brodbar/) || window.location.href.match(/myshopify/);
  if(!IsDebugMode) return;
  const Nav = document.querySelector("nav.header__inline-menu ul");
  const li = document.createElement("li");
  const anchor = document.createElement("a");
  const span = document.createElement("span");
  anchor.classList.add("header__menu-item","list-menu__item", "link", "link--text", "focus-inset");
  span.innerText = "VINTAGE";
  li.appendChild(anchor);
  anchor.appendChild(span);
  anchor.href = "#";
  Nav.insertBefore(li, [...Nav.querySelectorAll("li")].at(-1));
  
}